var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_1_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.4,
    height: 60.4,
    viewBox: "0 0 74.4 60.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M23.4,60.4c28.1,0,43.4-23.2,43.4-43.4V15a30.042,30.042,0,0,0,7.6-7.9,31.779,31.779,0,0,1-8.8,2.4,15.505,15.505,0,0,0,6.7-8.4,31.5,31.5,0,0,1-9.7,3.7A15.4,15.4,0,0,0,51.5,0,15.236,15.236,0,0,0,36.2,15.3a13.425,13.425,0,0,0,.4,3.5A43.525,43.525,0,0,1,5.2,2.8,15.228,15.228,0,0,0,9.9,23.2a14.607,14.607,0,0,1-6.9-2v.2a15.348,15.348,0,0,0,12.2,15,17.524,17.524,0,0,1-4,.5,14.279,14.279,0,0,1-2.9-.3A15.165,15.165,0,0,0,22.5,47.2,30.457,30.457,0,0,1,3.6,53.7c-1.2,0-2.4-.1-3.6-.2a42.826,42.826,0,0,0,23.4,6.9",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f9f3c744262f03375942cb5ecb10250c.svg";
export { ForwardRef as ReactComponent };